const Profile = () => {
  const profile = document.querySelector('.profile-panel');

  if (profile) {
    const editBtn = profile.querySelector('.js-profile-edit');
    const cancelBtn = profile.querySelector('.js-profile-cancel');
    const uploadBtn = profile.querySelector('.js-profile-photo');
    const saveBtn = profile.querySelector('.js-profile-save');
    const alert = document.querySelector('.profile-alert');
    const uploadSpinner = document.querySelector('.js-profile-photo-spinner');

    let oldValue;
    let data = {};

    editBtn.addEventListener('click', e => {
      const parent = e.currentTarget.parentNode;
      const input = parent.querySelector('input');

      profile.classList.add('is-editing');
      parent.classList.add('is-editable-editing');
      oldValue = input.value;

      input.removeAttribute('readonly');
      input.focus();
      input.addEventListener('change', event => {
        data.title = event.target.value;
      });
    });

    cancelBtn.addEventListener('click', e => {
      const parent = e.currentTarget.parentNode;
      const input = parent.querySelector('input');

      parent.classList.remove('is-editable-editing');
      input.value = oldValue ? oldValue : null;
      input.setAttribute('readonly', 'true');
      delete data.title;

      hideSaveBtn();
    });

    uploadBtn.addEventListener('click', () => {
      const fileInput = document.querySelector('.file-input');

      fileInput.click();

      fileInput.addEventListener('change', event => {
        profile.classList.add('is-editing');

        const output = document.querySelector('.profile-photo-img');
        output.src = URL.createObjectURL(event.target.files[ 0 ]);
        data.profile_picture = event.target.files[ 0 ];
        output.onload = function() {
          URL.revokeObjectURL(output.src); // free memory
        };
      });
    });

    saveBtn.addEventListener('click', () => {
      if (! isDataEmpty()) {
        save();
      }
    });

    function save() {
      const wpApi = window.wpApiSettings;
      const nonce = wpApi.nonce;

      // TODO: Make this queryelctorAll if editable fields gets added
      const editables = document.querySelector('.is-editable-editing');

      profile.classList.add('is-saving');

      saveBtn.innerHTML = 'Saving';

      if (hasProperty('profile_picture')) {
        uploadSpinner.style.display = 'flex';
      }

      fetch('/wp-json/profile/edit', {
        method: 'POST',
        body: getData(),
        headers: {
          'X-WP-Nonce': nonce,
        },
      })
        .then(res => res.json())
        .then(response => {
          if (response.code === 'profile_updated') {
            data = {}; //  reset data;

            hideSaveBtn();

            editables && editables.classList.remove('is-editable-editing');
            profile.classList.remove('is-saving');
            uploadSpinner.style.display = 'none';
            alert.style.display = 'block';
            alert.innerHTML = 'Profile updated.';
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err);

          alert.style.display = 'block';
          alert.style.color = 'red';
          alert.innerHTML = 'Profile was not updated. Try again.';
        });

      function getData() {
        const body = new FormData();
        Object.entries(data).forEach(([key, value]) => {
          body.append(key, value);
        });
        return body;
      }
    }

    function hideSaveBtn() {
      if (isDataEmpty()) {
        profile.classList.remove('is-editing');
        saveBtn.innerHTML = 'Save';
      }
    }

    // function hasData() {
    //   return Object.values(data).some(val => val !== null);
    // }

    function hasProperty(key) {
      return Object.keys(data).includes(key);
    }

    function isDataEmpty() {
      return Object.keys(data).length === 0 && data.constructor === Object;
    }
  }
};

export default Profile;
